import {
  Component,
  computed,
  effect,
  ElementRef,
  input,
  signal,
  ViewChild,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { CalendarFormControl } from '../calendar-form-control/calendar-form-control';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { DateInputFormControl } from '../date-input-form-control/date-input-form-control';
import { parseDate } from '../../../../core/utils/parser';
import { variantClass } from '../../../../core/utils/class';
import { FormControlMeta } from '../form-control-meta/form-control-meta';
import { FormValueControlBase } from '../../../directives/form-value-control-base';
import { CalendarBulk } from '../../icons/calendar-bulk';

@Component({
  selector: 'datepicker-form-control',
  imports: [
    NgClass,
    CalendarFormControl,
    NgClickOutsideDirective,
    DateInputFormControl,
    CalendarBulk,
    FormControlMeta,
  ],
  templateUrl: './datepicker-form-control.html',
  styleUrl: './datepicker-form-control.scss',
})
export class DatepickerFormControl extends FormValueControlBase<Date> {
  @ViewChild('control') controlRef!: ElementRef<HTMLElement>;

  minDate = input<Date | null>(null);
  maxDate = input<Date | null>(null);
  showControl = input<boolean>(true);

  calendarOpen = signal<boolean>(false);
  top = signal<boolean>(false);

  icon = CalendarBulk;
  override prefix = 'datepicker-form-control';

  private valueEffect = effect(() => {
    parseDate(this.value());
  });

  datepickerClasses = computed(() => {
    return {
      ...this.baseClasses(),
      [variantClass(this.prefix, 'top')]: this.top(),
    };
  });

  toggleCalendar() {
    if (this.disabled() || this.readonly()) return;

    this.top.set(this.updateMenuPosition());
    this.calendarOpen.set(!this.calendarOpen());
  }

  updateMenuPosition(): boolean {
    if (!this.controlRef) return false;

    const rect = this.controlRef.nativeElement.getBoundingClientRect();
    const menuHeight = 478;
    const spaceBelow = window.innerHeight - rect.bottom;

    return spaceBelow < menuHeight + 10;
  }

  onSelect(value: Date | null) {
    if (this.disabled() || this.readonly()) return;

    this.calendarOpen.set(false);
    this.setValue(value);
  }

  onDateInputChanged(value: Date | null | undefined) {
    if (this.disabled() || this.readonly()) return;

    this.setValue(value ?? null);
  }

  onDateFocused() {
    this.onFocus();
  }

  onDateBlurred() {
    this.onBlur();
  }
}
